import angular                           from 'angular'
import angularTranslate                  from 'angular-translate'
import angularTranslateLoaderStaticFiles from 'angular-translate-loader-static-files'
import angularDynamicLocale              from 'angular-dynamic-locale'
import angularSanitize                   from 'angular-sanitize'

import I18nFactory from './i18n.factory'

let module = angular.module('i18n', [
  angularTranslate,
  angularTranslateLoaderStaticFiles,
  angularDynamicLocale,
  angularSanitize
])

.config(($translateProvider, tmhDynamicLocaleProvider) => {
  'ngInject'

  $translateProvider.useSanitizeValueStrategy('sanitizeParameters')

  $translateProvider.useStaticFilesLoader({
    prefix: 'i18n/translations_',
    suffix: '.json'
  })

  tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js')
})

.run(($translate, tmhDynamicLocale, Localization, I18n) => {
  'ngInject'

  $translate.preferredLanguage(I18n.getDefaultLanguage())
  $translate.fallbackLanguage('en')
  $translate.use(I18n.getDefaultLanguage())
  $translate.refresh()
  tmhDynamicLocale.set(I18n.getDefaultLanguage())
})

.factory('I18n', I18nFactory)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/common/i18n/index.js